import React from 'react';
import { ClaimMetricBase, ProviderBreakdownItem } from './ClaimMetricBase';
import { useComputedColorScheme, useMantineTheme } from '@mantine/core';
import { useClaimPaginationStore } from 'store/ClaimPaginationStore';
import {
  ALL_CLAIM_TAB,
  useClaimTabFilterStore,
} from 'store/ClaimTabFilterStore';
import { nonTerminalClaimStatusEnumValues } from '@billing/validation/baseClaim';
import { CLAIM_TARIFF_STATUS } from '@billing/validation/tariff';
interface ErrorClaimsCardProps {
  total?: number;
  providers?: ProviderBreakdownItem[];
  loading: boolean;
  icon: React.ComponentType<any>;
  path?: string;
  navigate: (path: string) => void;
}

export const ErrorClaimsCard: React.FC<ErrorClaimsCardProps> = ({
  total,
  providers = [],
  loading,
  icon,
  navigate,
  path = '/claims',
}) => {
  const theme = useMantineTheme();
  const mode = useComputedColorScheme('dark');
  const badgeColour = theme.colors[`warning-yellow-${mode}`][0];
  const { setColumnFilters, setPageIndex } = useClaimPaginationStore();
  const { clearSubStatuses, setActiveTab, toggleSubStatus } =
    useClaimTabFilterStore();

  const applyFilter = (providerID: string) => {
    setActiveTab(ALL_CLAIM_TAB);
    clearSubStatuses();
    toggleSubStatus(CLAIM_TARIFF_STATUS.REJECTED);
    setPageIndex(0);
    setColumnFilters([]);
    const newFilter = [
      {
        id: 'status',
        value: [...nonTerminalClaimStatusEnumValues],
      },
      {
        id: 'tariffs.status',
        value: CLAIM_TARIFF_STATUS.REJECTED,
      },
      {
        id: 'providerID',
        value: providerID,
      },
    ];
    setColumnFilters(newFilter);
    navigate('/claims');
  };

  return (
    <ClaimMetricBase
      title="Error Claims"
      total={total}
      providers={providers}
      loading={loading}
      badgeColour={badgeColour}
      onClick={applyFilter}
      icon={icon}
      path={path}
      headerLabel="Top Providers"
      emptyLabel="No error claim providers"
      dataTestId="error-claims-card"
    />
  );
};
